import { ROLES } from "../../../Constants/Strings";
import { toProperCase } from "../../../Utils";

export const SITE_FIELDS = [
  { key: "project_name", label: "Project", type: "text", disabled: true },
  {
    key: "project_type",
    label: "Project type",
    type: "text",
    disabled: true,
    format: (val) => toProperCase(val),
  },
  {
    key: "project_category",
    label: "Category",
    type: "text",
    disabled: true,
    format: (val) => toProperCase(val),
  },
  {
    key: "status",
    label: "Status",
    type: "select",
    options: [
      { value: "PENDING", label: "Not Started" },
      { value: "IN_PROGRESS", label: "In Progress" },
      { value: "COMPLETED", label: "Completed" },
    ],
  },
  { key: "state", label: "State", type: "text" },
  { key: "region", label: "Region", type: "text" },
  { key: "zone", label: "Zone", type: "text" },
  { key: "district", label: "District", type: "text", className: "truncate" },
  { key: "location_url", label: "Location", type: "link" },
];

export const SITE_TOAST_MESSAGES = {
  USER_ADD_SUCCESS: "User Added Successfully",
  USER_ADD_FAILED: "Failed to add user!",
  USERS_NOT_SELECTED: "No users selected!",
  USER_ROLE_NOT_SELECTED: "Please select both user and role",
  TASK_ADDITION_FAILURE: "Failed to add Task",
  USERS_FETCH_FAILED: "Failed to fetch Users",
  TASK_DELETION_FAILURE: "Failed to remove tasks",
};

export const ROLE_DROPDOWN_OPTIONS = [
  { label: "Site Engineer", value: ROLES.SITE_ENGINEER },
  { label: "Project Engineer", value: ROLES.PROJECT_ENGINEER },
];
